import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CONFIRM_CHANGES: "Bekreft endringer",
      CONFIRM_ORDER: "Bekreft bestillingen",
      LAST_CHANCE: "Legg til noe ekstra?",
      ORDER: "Bestilling",
      SHOW_MORE: "Vis mer",
      MEALS: "Middager",
      ADDONS: "Dagligvarer",
      UNDO_CHANGES: "Angre endringer",
      PORTIONS: "porsjoner",
      SUMMARY: "Oppsummering",
      DISCOUNT: "Rabatt",
      DELIVERY: "Levering",
      TOTAL: "Totalt",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan ikke bestille før startuke",
      NOTIFICATION_DELIVERY_STARTED: "Dine leveranser er gjenopptatt",
    },

    se: {
      CONFIRM_CHANGES: "Bekräfta ändringar",
      CONFIRM_ORDER: "Bekräfta beställningen",
      LAST_CHANCE: "Lägg till något extra?",
      ORDER: "Beställning",
      SHOW_MORE: "Visa mer",
      MEALS: "Middagar",
      ADDONS: "Livsmedel",
      UNDO_CHANGES: "Ångra ändringar",
      PORTIONS: "portioner",
      SUMMARY: "Sammanfattning",
      DISCOUNT: "Rabatt",
      DELIVERY: "Leverans",
      TOTAL: "Totalt",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan inte beställa innan startvecka",
      NOTIFICATION_DELIVERY_STARTED: "Du har nu leveranser varje vecka!",
    },

    dk: {
      CONFIRM_CHANGES: "Bekræft ændringer",
      CONFIRM_ORDER: "Bekræft ordre",
      LAST_CHANCE: "Tilføj noget ekstra?",
      ORDER: "Bestilling",
      SHOW_MORE: "Vis mere",
      MEALS: "Retter",
      ADDONS: "Specialvarer",
      UNDO_CHANGES: "Fortryd ændringer",
      PORTIONS: "portioner",
      SUMMARY: "Opsummering",
      DISCOUNT: "Rabat",
      DELIVERY: "Levering",
      TOTAL: "I alt",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan ikke bestille før startuge",
      NOTIFICATION_DELIVERY_STARTED: "Dine leveringer er startet",
    },
  } as const
)[language];
